import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import LocalCarWashIcon from '@mui/icons-material/LocalCarWash';

const Capabilities = () => {
  const services = [
    {
      icon: <BuildIcon sx={{ fontSize: 60, color: '#ffc107' }} />,
      title: 'Maintenance Services',
      description: 'Leverage agile framework to provide a robust high level synopsys overviews. Leverage agile framework to provide a robust high level synopsys overviews.'
    },
    {
      icon: <LocalCarWashIcon sx={{ fontSize: 60, color: '#1976d2' }} />,
      title: 'Cleaning Services',
      description: 'Leverage agile framework to provide a robust high level synopsys overviews. Leverage agile framework to provide a robust high level synopsys overviews.'
    },
    {
      icon: <CarRepairIcon sx={{ fontSize: 60, color: '#d32f2f' }} />,
      title: 'Repair and Body Work',
      description: 'Leverage agile framework to provide a robust high level synopsys overviews. Leverage agile framework to provide a robust high level synopsys overviews.'
    }
  ];

  return (
    <Box
      id="services"
      sx={{
        backgroundColor: '#f8f9fa',
        padding: { xs: '60px 20px', sm: '80px 40px', md: '100px 80px' },
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(26, 35, 126, 0.15), transparent)',
          pointerEvents: 'none'
        }
      }}
    >
      <Container maxWidth="xl" sx={{ width: '100%' }}>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="flex-start">
          <Grid item xs={12} md={4}>
            <Box sx={{ maxWidth: { xs: '100%', md: '400px' } }}>
              <Typography
                sx={{
                  color: '#ff6f00',
                  fontSize: { xs: '12px', md: '14px' },
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  marginBottom: '16px',
                  display: 'block'
                }}
              >
                SERVICES
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '28px', sm: '32px', md: '42px', lg: '48px' },
                  fontWeight: 'bold',
                  color: '#1a237e',
                  marginBottom: { xs: '20px', md: '24px' },
                  lineHeight: 1.2
                }}
              >
                Our Capabilities
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#666',
                  fontSize: { xs: '15px', md: '16px' },
                  lineHeight: 1.6
                }}
              >
                We will bring the breathe of our experience and industry knowledge to help you succeed
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <Grid container spacing={{ xs: 3, md: 4 }}>
              {services.map((service, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{
                      height: '100%',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      border: '1px solid rgba(0,0,0,0.05)',
                      borderRadius: '12px',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      backgroundColor: 'white',
                      position: 'relative',
                      overflow: 'hidden',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '4px',
                        background: 'linear-gradient(90deg, #ff6f00, #ff8f00)',
                        transform: 'scaleX(0)',
                        transformOrigin: 'left',
                        transition: 'transform 0.3s ease'
                      },
                      '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
                        '&::before': {
                          transform: 'scaleX(1)'
                        },
                        '& .service-icon': {
                          transform: 'scale(1.1) rotate(5deg)'
                        }
                      }
                    }}
                  >
                    <CardContent sx={{ padding: { xs: '24px', md: '32px' }, flexGrow: 1 }}>
                      <Box 
                        sx={{ 
                          marginBottom: { xs: '20px', md: '24px' },
                          display: 'inline-block',
                          padding: '16px',
                          borderRadius: '12px',
                          background: 'linear-gradient(135deg, rgba(255, 111, 0, 0.1) 0%, rgba(255, 143, 0, 0.05) 100%)',
                          transition: 'all 0.3s ease'
                        }}
                        className="service-icon"
                      >
                        {service.icon}
                      </Box>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 'bold',
                          color: '#1a237e',
                          marginBottom: { xs: '12px', md: '16px' },
                          fontSize: { xs: '18px', md: '20px' },
                          lineHeight: 1.3
                        }}
                      >
                        {service.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#666',
                          lineHeight: 1.6,
                          fontSize: { xs: '13px', md: '14px' }
                        }}
                      >
                        {service.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Capabilities;
